module.exports = __webpack_public_path__ + "media/200514_YEAH_CI_neuer_Look_Y_Sinus_001.1ca65ccf.mp4";